/**
 * Captcha Configuration
 * 
 * This file contains configuration for different types of captcha implementations.
 * Currently supporting Google reCAPTCHA v2.
 * 
 * To get your own reCAPTCHA keys:
 * 1. Go to https://www.google.com/recaptcha/admin/create
 * 2. Select reCAPTCHA v2
 * 3. Add your domain
 * 4. Get the site key and secret key
 * 5. Add the site key to your .env file as VITE_RECAPTCHA_SITE_KEY
 */

export interface CaptchaConfig {
    siteKey: string;
    theme: 'light' | 'dark';
    size: 'compact' | 'normal' | 'invisible';
    enabled: boolean;
}

// Default configuration
export const captchaConfig: CaptchaConfig = {
    siteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY || '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    theme: 'light',
    size: 'normal',
    enabled: true,
};



// Validation helper
export const isCaptchaEnabled = (): boolean => {
    return captchaConfig.enabled && Boolean(captchaConfig.siteKey);
};

// Get captcha theme based on app theme
export const getCaptchaTheme = (isDarkMode: boolean): 'light' | 'dark' => {
    return isDarkMode ? 'dark' : 'light';
};
